import { createContext } from "react";

const popupStore = createContext({
	//spell correction and assigning empty function while initalizing to avoid undefined errors
	activePopup: '',
	setActivePopup: () => {},
});

export default popupStore;